import { render, staticRenderFns } from "./detailExamin.vue?vue&type=template&id=6e4ccaad&scoped=true"
import script from "./detailExamin.vue?vue&type=script&lang=js"
export * from "./detailExamin.vue?vue&type=script&lang=js"
import style0 from "./detailExamin.vue?vue&type=style&index=0&id=6e4ccaad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4ccaad",
  null
  
)

export default component.exports